import React from "react";
import {
  Container,
  Baseline,
  Info,
  Title,
  SocialMedia,
} from "./styles/Contact";
import email from "../images/email.svg";
import phone from "../images/phone.svg";
import facebook from "../images/facebook.svg";
import insta from "../images/insta.svg";
import seamless from "../images/seamless.svg";
import opentable from "../images/opentable.svg";
import uberEat from "../images/UberLogo.png";

function Contact() {
  return (
    <Container>
      <Title id="contact"> Contact </Title>
      <Info>
        <div className="phone">
          <img src={phone} alt="phone" />
          <p className="phone">(212) 874-2705</p>
        </div>
        <div className="email">
          <img src={email} alt="email" />
          <p>laboitenyc@gmail.com</p>
        </div>
      </Info>
      <Baseline>You can also find us on :</Baseline>
      <SocialMedia>
        <a href="https://www.instagram.com/explore/locations/8003401/la-boite-en-bois?hl=en">
          <img src={insta} alt="insta" />
        </a>
        <a href="https://www.facebook.com/La-Boite-en-Bois-106518869416333">
          <img className="facebook" src={facebook} alt="facebook" />
        </a>
        <a href="https://www.seamless.com/menu/la-boite-en-bois-75-w-68th-st-new-york/315251">
          <img src={seamless} alt="seamless" />
        </a>
        <a href="https://www.ubereats.com/new-york/food-delivery/la-boite-en-bois/7UGRj8CJTWWYdcnMXNX0Zg">
          <img src={uberEat} alt="Uber" />
        </a>
      </SocialMedia>
    </Container>
  );
}

export default Contact;
